import React, {useState, useEffect} from 'react';
import {Table, Input, List, Tabs, Badge, Tooltip, Select, Pagination} from 'antd';
import history from "../../../libs/history";
import styles from './layout.module.less'

import store from "./store";
import projectStore from '../project/store'
import {observer} from 'mobx-react';
import lodash from "lodash";
import SearchForm,{SearchFormItem} from "../../../components/SearchForm";

import {InfoCircleOutlined} from '@ant-design/icons';

// the hook
import { useTranslation } from 'react-i18next';


const {TabPane} = Tabs;
const {Search} = Input;

export default observer(function () {
  const {t, i18n} = useTranslation()

  const columns = [
    // {
    //   title: '',
    //   dataIndex: 'type',
    //   key: 'type',
    //   className: 'pl0',
    //   width: 35,
    //   fixed: true,
    //   render: (val,info) => <div className={[styles.badge,i18n.language==='en'?styles.autoWidth:''].join(' ')}>
    //    {t(info.type_alias.charAt(0)==='销'?'购':info.type_alias.charAt(0))}
    //   </div>,
    // },
    {
      title: t('品牌'),
      dataIndex: 'brand',
      align: 'center',
      fixed: true,
      width: 150,
      render:(value,info)=>{
        return (<><span className={[styles.badge,i18n.language==='en'?styles.autoWidth:''].join(' ')}>
          {t(info?.catalogName?.charAt(0)==='销'?'购':info?.catalogName?.charAt(0))}
        </span>
        {value}</>)
      }
    },
    {
      title: t('产品品名'),
      dataIndex: 'name',
      align: 'center',
      fixed: true,
      width: 130,
    },
    {
      title: t('货号'),
      dataIndex: 'factoryCode',
      align: 'center',
      fixed: true,
      width: 90,
    },
    {
      title: t('规格'),
      dataIndex: 'formats',
      align: 'center',
      fixed: true,
      width: 50,
    },
    {
      title: t('单价'),
      dataIndex: 'price',
      align: 'center',
      fixed: true,
      render: (val, record, index) => <div>{val ? val + (record.type * 1 === 2 ? t('元/月') : t('元')) : '-'}</div>,
    },
    {
      title: t('租期'),
      dataIndex: 'duration',
      width: 60,
      align: 'center',
      fixed: true,
      render: val => <div>{val ? val + t('月') : '-'}</div>,
    },
    {
      title: t('数量'),
      dataIndex: 'number',
      width: 60,
      align: 'center',
      fixed: true,
    },
    {
      title: t('合计'),
      dataIndex: 'totalPrice',
      align: 'center',
      fixed: true,
      render: (val, record, index) => <div>{val ? val + t('元') : '-'}</div>,
    },
    // {
    //   title: t('项目编号'),
    //   dataIndex: 'extra_sn',
    //   align: 'center',
    //   fixed: true,
    //   render:  (val, record, index) => {
    //     let project=projectStore.records.filter(v=>v.id===val*1)
    //     let txt='-'
    //     if(project.length){
    //       txt=project[0]['sn']
    //     }
    //     return <div>{txt}</div>
    //   },
    // },
    {
      title: t('预计到货'),
      dataIndex: 'period',
      width: 70,
      align: 'center',
      fixed: true,
      render: val => <div>{val}</div>,
    },
    {
      title: t('状态'),
      dataIndex: 'statusName',
      width: 80,
      align: 'center',
      fixed: true,
      render: (val, record) => record['tag_alias'] ? (
        <Tooltip title={t(record['tag_alias'])} color='red' key={record['id']}>
          <span style={{color: 'red'}}>{t(val)} </span>
          <InfoCircleOutlined style={{color: 'red'}}/>
        </Tooltip>
      ) : t(val)
    },
  ]

  const [activeKey, setActiveKey] = useState(0)
  const [loading, setLoading] = useState(false)

  let data = [...store.records]
  let list1 = data
  let list2 = lodash.filter(data, {'status': '0'})
  let list3 = [].concat(lodash.filter(data, {'status': '10'}), lodash.filter(data, {'status': '20'}))
  let list4 = lodash.filter(data, {'status': '11'})
  let listData = [list1, list2, list3, list4]

  useEffect(() => {
    // setLoading(true)
    store.fetchRecords();

    // projectStore.fetchRecords();
  }, [])

  const makeRowClassName = (record, index) => {
    return record.disabled ? styles.disabled : ''
  }

  const handleTabChange = (key) => {
    setActiveKey(key)
    // if (['2', '3'].indexOf(key) !== -1) {
    //   store.updateReadStatus((key * 1 + 8) + '').then()
    // }
  }

  const onSearch = (values) => {
    console.log('values',values);
    store.spp=values;
    store.fetchRecords();
  }

  // 分类标签数字
  const renderBadge = (item, index) => {
    let curArr = listData[index]
    let count = curArr.filter(v => !v['isRead']).length

    if (item === t('全部求购单')) {
      return (<span>{item}</span>)
    } else {
      return (
        <span>{item}<Badge count={count} overflowCount={99} size="small" className="site-badge"/></span>
      )
    }
  }

  return (
    <React.Fragment>
      <div className={[styles.cart, 'rest-nav1', i18n.language === 'en' ? 'rest-nav1-en' : ''].join(" ")}>

        <div className={styles.listTitle}>
          <span style={{paddingLeft: '0.0781rem'}}>{t('订单状态：')}</span>
        </div>

        <SearchForm onFinish={onSearch}>
          <SearchFormItem title={t('产品名称')} name='productName' span={8}>
            <Input placeholder={t("请输入")} allowClear/>
          </SearchFormItem>
          <SearchFormItem title={t('求购编号')} name='sn' span={8}>
            <Input placeholder={t("请输入")} allowClear/>
          </SearchFormItem>
          {/* <SearchFormItem title={t('项目编号')} name='extraSn' span={8}>
            <Input placeholder={t("请输入")} allowClear/>
          </SearchFormItem> */}
          {/* <SearchFormItem title={t('中心号')} name='center_sn' span={8}>
            <Input placeholder={t("请输入")} allowClear/>
          </SearchFormItem> */}
          <SearchFormItem title={t('货号')} name='factoryCode' span={8}>
            <Input placeholder={t("请输入")} allowClear/>
          </SearchFormItem>
          <SearchFormItem title={t('品牌')} name='brand' span={8}>
            <Input placeholder={t("请输入")} allowClear/>
          </SearchFormItem>
        </SearchForm>

        <div className="mainBox">

          <Tabs defaultActiveKey={activeKey} className={styles.badgeTabs} onChange={handleTabChange}>
            {
              [t('全部求购单'), t('待报价'), t('已报价'), t('已关闭')].map((item, index) => {
                return (
                  <TabPane
                    key={index}
                    tab={renderBadge(item, index)}>


                    <List
                      header=''
                      footer=''
                      dataSource={listData[index]}
                      split={false}
                      pagination={false}
                      loading={loading}
                      renderItem={(item, index) => (
                        <List.Item>

                          <div style={{width: '100%'}}>
                            <div className={styles.innerTitle}>
                              <div className={styles.t1}>{t('求购编号')}： {item['sn']}</div>
                              <div className={styles.t2}>{t('求购时间')}： {item['createdAt']}</div>
                            </div>
                            <Table className={styles.table}
                                   pagination={false}
                                   bordered
                                   rowClassName={makeRowClassName}
                                   dataSource={item.inquiryItems}
                                   rowKey='id'
                                   columns={columns}/>

                          </div>

                        </List.Item>
                      )}
                    />

                    {/* {
                      listData[index].length ? (
                        <div style={{
                          textAlign: 'right',
                          margin: '0.5208rem 0.026rem 0.2083rem',
                          fontSize: "0.0625rem"
                        }}>{t('总计')} {listData[index].length} {t('个记录')}</div>
                      ) : null
                    } */}
                    <div className="pagination_container">
                      <Pagination
                        showSizeChanger={true}
                        showLessItems={true}
                        current={store.page}
                        pageSize={store.pageSize}
                        total={store.pageTotal}
                        showTotal={total => `共 ${total} 条`}
                        pageSizeOptions={['10', '20', '50', '100']}
                        onChange={store.pageChange}
                    />
                    </div>
                  </TabPane>
                )
              })
            }

          </Tabs>
        </div>


      </div>

    </React.Fragment>
  )

})

